import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import SupportContact from "../../components/SupportContact/SupportContact";

const TeacherSupportInfo = () => {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center text-center p-4"
      style={{ height: "70vh" }}
    >
      <h3 className="fw-bold mb-3">
        <FormattedMessage id="NoClassesTitle" />
      </h3>

      <p style={{ fontSize: "1rem" }}>
        <FormattedMessage id="NoClassesInfo" />
      </p>

      <SupportContact />

      <Link to="/teacher/aboutUs" className="mt-3">
        <FormattedMessage id="ContactSupportLink" />
      </Link>
    </div>
  );
};

export default TeacherSupportInfo;
